import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Feature from 'domain/entity/feature';
import Preset from 'domain/entity/preset';
import ReadFeaturesClient from 'use-case/features/read/readFeaturesClient';

export default (httpClient: httpClientFunction, baseUrl: string): ReadFeaturesClient => () =>
    httpClient(`${baseUrl}/dashboards/features`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asFeatures)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asFeatures = (featuresJson: featuresJsonType) =>
    featuresJson.map(
        (featureItem: featureJsonType) =>
            new Feature(
                featureItem.name,
                featureItem.key,
                asPresets(featureItem.presets),
                asAtomisablePresets(featureItem.atomisable_presets)
            )
    );

const asPresets = (presetsJson: presetsJsonType) =>
    presetsJson.map((presetJson: presetJsonType) => new Preset(presetJson.name, presetJson.key, presetJson.widget_types));

const asAtomisablePresets = (atomisablePresetsJson: atomisablePresetJsonType) =>
    atomisablePresetsJson.map((atomisablePresetJson: { name: string; key: string }) => ({
        name: atomisablePresetJson.name,
        key: atomisablePresetJson.key,
    }));

type presetJsonType = {
    name: string;
    key: string;
    // eslint-disable-next-line camelcase
    widget_types: Array<string>;
};

type featuresJsonType = Array<featureJsonType>;

type featureJsonType = {
    name: string;
    key: string;
    presets: presetsJsonType;
    ['atomisable_presets']: atomisablePresetJsonType;
};

type atomisablePresetJsonType = Array<{
    name: string;
    key: string;
}>;
type presetsJsonType = Array<presetJsonType>;
